<div class="main-section modalclosed" id="main">
    <mat-card>
        <div class="col-lg-12 d-flex flex-row p-3 eca-summary-grid">
            <div class="col-lg-auto d-flex flex-column justify-content-end">
                <a matTooltip="Go to Hubspot Contact Page"
                    href="https://app.hubspot.com/contacts/20693631/record/0-1/{{contactID}}" target="_blank">
                    <div class="link_button">
                        <img src="assets/icon_hubspot_tp.png" style="height:32px; width:32px; object-fit: contain;">
                    </div>
                </a>
            </div>
            <div class="col-lg-3 d-flex flex-column justify-content-center align-items-start">
                <h2 demibold>{{formData.hs_full_name}} </h2>
                <p style="margin-bottom: 0px">{{formData.admin_company_name}}</p>
            </div>

            <div class="col-lg-2 d-flex flex-column justify-content-center align-items-start">
                <p>Registered:</p>
                <p style="margin-bottom: 0px">
                    {{ (formData.admin_registration_date != " ") ? (formData.admin_registration_date | date:'MMM d, y, h:mm:ss a') : 'N/A' }}
                </p>
            </div>

            <div class="col-lg-2 d-flex flex-column justify-content-center align-items-start">
                <p>Last Quote</p>
                <p style="margin-bottom: 0px">
                    {{(formData.admin_last_quote_date != " ") ? (formData.admin_last_quote_date | date:'MMM d, y, h:mm:ss a') : 'N/A'}}
                </p>
            </div>
        </div>
    </mat-card>

    <div class="sectionspacer"></div>

    <mat-card class="box-shadow p-2 mb-3">
        <div class="row p-3" style="display: flex; min-height: 350px;">
            <div style="flex: 1 1 0; display: flex; flex-direction: column;">
                <!-- Contact info form and button here -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h2 class="accent-text">Contact Information</h2>
                </div>
                <!-- One column per system of record: Hubspot and QuickParts read
                     side by side for mismatch checks, NetSuite holds the single
                     editable association field. -->
                <div class="contact-fields">
                    <div class="row">
                        <div class="col-lg-4 contact-source-col">
                            <h3 class="contact-source-title">Hubspot</h3>
                            <div class="readonly-field">
                                <span class="readonly-label">Account Name</span>
                                <span class="readonly-value">{{ display(formData.hs_full_name) }}</span>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Email</span>
                                <span class="readonly-value">{{ display(formData.hs_email) }}</span>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Phone</span>
                                <span class="readonly-value">{{ display(formData.hs_phone) }}</span>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Country</span>
                                <span class="readonly-value">{{ display(formData.hs_country) }}</span>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Contact ID</span>
                                <span class="readonly-value">{{ display(formData.contactID) }}</span>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Company Name</span>
                                <span class="readonly-value">{{ display(formData.hs_account_name) }}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 contact-source-col">
                            <h3 class="contact-source-title">Quickparts</h3>
                            <!-- Every editable field in this column shares the one Undo/Save at the bottom -->
                            <div class="editable-field">
                                <div class="name-fields">
                                    <mat-form-field appearance="fill">
                                        <mat-label>First Name</mat-label>
                                        <input matInput name="firstName" [(ngModel)]="firstNameDraft"
                                            [maxlength]="firstNameMaxLength" [disabled]="savingQuickparts">
                                        <mat-icon matSuffix class="editable-icon" matTooltip="Editable">edit</mat-icon>
                                        <mat-hint align="end">{{ firstNameDraft.length }} / {{ firstNameMaxLength }}</mat-hint>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill">
                                        <mat-label>Last Name</mat-label>
                                        <input matInput name="lastName" [(ngModel)]="lastNameDraft"
                                            [maxlength]="lastNameMaxLength" [disabled]="savingQuickparts">
                                        <mat-icon matSuffix class="editable-icon" matTooltip="Editable">edit</mat-icon>
                                        <mat-hint align="end">{{ lastNameDraft.length }} / {{ lastNameMaxLength }}</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="readonly-field">
                                <span class="readonly-label">Email</span>
                                <span class="readonly-value">
                                    {{ display(formData.admin_email) }}
                                    @if (formData.hs_email != formData.admin_email) {
                                        <mat-icon class="mismatch-icon" matTooltip="MISMATCH">warning</mat-icon>
                                    }
                                </span>
                            </div>
                            <div class="editable-field">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label>Phone</mat-label>
                                    <input matInput name="phone" [(ngModel)]="phoneDraft"
                                        [maxlength]="phoneMaxLength" [disabled]="savingQuickparts">
                                    <mat-icon matSuffix class="editable-icon" matTooltip="Editable">edit</mat-icon>
                                    <mat-hint align="end">{{ phoneDraft.length }} / {{ phoneMaxLength }}</mat-hint>
                                </mat-form-field>
                            </div>
                            @if (facilityEditable) {
                                <div class="editable-field">
                                    <mat-form-field appearance="fill" style="width:100%;">
                                        <mat-label>Facility</mat-label>
                                        <mat-select name="facility" [(ngModel)]="facilityDraft" [disabled]="savingQuickparts"
                                            placeholder="Not set">
                                            @for (facility of facilities; track facility.cfgId) {
                                                <mat-option [value]="facility.cfgId">{{ facility.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="editable-field">
                                    <mat-form-field appearance="fill" style="width:100%;">
                                        <mat-label>Currency</mat-label>
                                        <mat-select name="currency" [(ngModel)]="currencyDraft" [disabled]="savingQuickparts"
                                            placeholder="Not set">
                                            @for (currency of currencies; track currency) {
                                                <mat-option [value]="currency">{{ currency }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            } @else {
                                <div class="readonly-field">
                                    <span class="readonly-label">Facility</span>
                                    <span class="readonly-value">{{ facilityLabel }}</span>
                                </div>
                                <div class="readonly-field">
                                    <span class="readonly-label">Currency</span>
                                    <span class="readonly-value">{{ display(defaultCurrency) }}</span>
                                </div>
                            }
                            <div class="readonly-field">
                                <span class="readonly-label">Profile ID</span>
                                <span class="readonly-value">{{ display(formData.profileID) }}</span>
                            </div>
                            <div class="editable-field">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label>Company Name</mat-label>
                                    <input matInput name="companyName" [(ngModel)]="companyNameDraft"
                                        [maxlength]="companyNameMaxLength" [disabled]="savingQuickparts">
                                    <mat-icon matSuffix class="editable-icon" matTooltip="Editable">edit</mat-icon>
                                    <mat-hint align="end">{{ companyNameDraft.length }} / {{ companyNameMaxLength }}</mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="editable-actions">
                                <button mat-button type="button" (click)="resetQuickparts()"
                                    [disabled]="!quickpartsChanged || savingQuickparts">
                                    Undo
                                </button>
                                <button mat-raised-button color="accent" type="button" (click)="saveQuickparts()"
                                    [disabled]="!canSaveQuickparts">
                                    Save
                                </button>
                            </div>
                        </div>
                        <div class="col-lg-4 contact-source-col">
                            <h3 class="contact-source-title">NetSuite</h3>
                            <div class="editable-field">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label>Account ID</mat-label>
                                    <input matInput name="netsuiteAccountId" [(ngModel)]="netsuiteAccountIdDraft"
                                        [maxlength]="netsuiteAccountIdMaxLength" [disabled]="savingNetsuiteAccountId">
                                    <mat-icon matSuffix class="editable-icon" matTooltip="Editable">edit</mat-icon>
                                    <mat-hint align="end">{{ netsuiteAccountIdDraft.length }} / {{ netsuiteAccountIdMaxLength }}</mat-hint>
                                </mat-form-field>
                                <div class="editable-actions">
                                    <button mat-button type="button" (click)="resetNetsuiteAccountId()"
                                        [disabled]="!netsuiteAccountIdChanged || savingNetsuiteAccountId">
                                        Undo
                                    </button>
                                    <button mat-raised-button color="accent" type="button"
                                        (click)="saveNetsuiteAccountId()" [disabled]="!canSaveNetsuiteAccountId">
                                        Associate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-3">
                    <button id="btnCreateQuote" class="flexcentered CreateQuoteButton" mat-raised-button color="accent" (click)="newQuotemodalShow()"
                        [disabled]="false">
                        <i class='bx bx-plus'></i> <span class="cq-btn white-text">New Blank Quote</span>
                    </button>
                </div>
            </div>
            <div
                style="flex: 1 1 0; min-width: 320px; display: flex; flex-direction: column; justify-content: flex-start;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h2 class="accent-text">Part Lookup</h2>
                </div>
                <div style="flex: 1 1 0; min-height: 0;">
                    <app-part-lookup [profileId]="formData.profileID"></app-part-lookup>
                </div>
            </div>
        </div>
    </mat-card>



    <!-- Activity Block -->
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Currently Active Quotes
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="p-3" [hidden]="quoterows.length !== 0">No active quotes found.</p>
            <div [hidden]="quoterows.length === 0">
            <table mat-table [dataSource]="quoteDataSource" class="mat-elevation-z0">
                <!-- ECA Status Column -->
                <ng-container matColumnDef="ecastatus">
                    <th mat-header-cell *matHeaderCellDef>ECA Status</th>
                    <td mat-cell *matCellDef="let quote">
                        @if (quote.ecastatusint == '1') {
                            <mat-chip-set>
                                <mat-chip class="status-chip error-chip" aria-hidden="false">
                                    <mat-icon>warning</mat-icon>&nbsp; {{quote.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                        @if (quote.ecastatusint == '2') {
                            <mat-chip-set>
                                <mat-chip class="status-chip warning-chip" aria-hidden="false">
                                    <mat-icon>help_outline</mat-icon>&nbsp; {{quote.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                        @if (quote.ecastatusint == '3') {
                            <mat-chip-set>
                                <mat-chip class="status-chip success-chip" aria-hidden="false">
                                    <mat-icon>check_circle</mat-icon>&nbsp; {{quote.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                    </td>
                </ng-container>

                <!-- Quote ID Column -->
                <ng-container matColumnDef="quoteID">
                    <th mat-header-cell *matHeaderCellDef>Quote ID</th>
                    <td mat-cell *matCellDef="let quote" (click)="getQuoteDetail(quote.quoteID, quote.ecastatusint)">
                        <a class="cursor text-decoration-none"><span class="demibold green">ID {{quote.quoteID}}</span></a>
                    </td>
                </ng-container>

                <!-- Origin Column — 3570. Deliberately a quiet outlined pill rather than a
                     filled mat-chip, so it doesn't compete with the ECA status beside it. -->
                <ng-container matColumnDef="origin">
                    <th mat-header-cell *matHeaderCellDef>Origin</th>
                    <td mat-cell *matCellDef="let quote">
                        <span class="origin-pill" [class.origin-pill-online]="quote.origin === 'Online'"
                            [class.origin-pill-unknown]="quote.origin === 'Unknown'"
                            [matTooltip]="quote.origin === 'Online' ? 'Created by customer'
                                : quote.origin === 'Sales' ? 'Created by Quickparts'
                                : 'Origin could not be determined'">
                            {{quote.origin}}
                        </span>
                    </td>
                </ng-container>

                <!-- Date Created Column -->
                <ng-container matColumnDef="datecreated">
                    <th mat-header-cell *matHeaderCellDef>Date Created</th>
                    <td mat-cell *matCellDef="let quote">
                        <span>{{quote.datecreated}}</span>
                    </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let quote">
                        <span class="demibold green">{{quote.status}}</span>
                    </td>
                </ng-container>

                <!-- Amount Column — 3621. No currency symbol: active-quotes doesn't say
                     which currency each quote is in, and the session currency belongs to
                     whichever quote was opened last, so a symbol could be wrong. -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let quote">
                        <span>{{ quote.amount != null ? (quote.amount | number:'1.2-2') : '—' }}</span>
                    </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let quote" style="align-items: center; display: inline-flex; min-height: 52px;">
                        @if (quote.ecastatusint == '2') {
                            <button id="eca{{quote.quoteID}}"
                                mat-mini-fab
                                (click)="sendECAmodalShow(quote.quoteID)">
                                <mat-icon>send</mat-icon>
                            </button>
                            <span id="out{{quote.quoteID}}" class="small grey demibold ms-3">Send ECA Email</span>
                        } @else {
                            <span id="out{{quote.quoteID}}" class="small grey demibold ms-3">ECA Status Set</span>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="activityColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: activityColumns;"></tr>
            </table>
            <mat-paginator #quotePaginator
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 50]"
                showFirstLastButtons>
            </mat-paginator>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Current Orders
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="p-3" [hidden]="orderrows.length !== 0">No current orders found.</p>
            <div [hidden]="orderrows.length === 0">
            <table mat-table [dataSource]="orderDataSource" class="mat-elevation-z0">
                <!-- ECA Status Column -->
                <ng-container matColumnDef="ecastatus">
                    <th mat-header-cell *matHeaderCellDef>ECA Status</th>
                    <td mat-cell *matCellDef="let order">
                        @if (order.ecastatusint == '1') {
                            <mat-chip-set>
                                <mat-chip class="status-chip error-chip" aria-hidden="false">
                                    <mat-icon>warning</mat-icon>&nbsp;{{order.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                        @if (order.ecastatusint == '2') {
                            <mat-chip-set>
                                <mat-chip class="status-chip warning-chip" aria-hidden="false">
                                    <mat-icon>help_outline</mat-icon>&nbsp;{{order.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                        @if (order.ecastatusint == '3') {
                            <mat-chip-set>
                                <mat-chip class="status-chip success-chip" aria-hidden="false">
                                    <mat-icon>check_circle</mat-icon>&nbsp;{{order.ecastatus}}
                                </mat-chip>
                            </mat-chip-set>
                        }
                    </td>
                </ng-container>

                <!-- Order ID Column -->
                <ng-container matColumnDef="quoteID">
                    <th mat-header-cell *matHeaderCellDef>Order ID</th>
                    <td mat-cell *matCellDef="let order" (click)="getOrderDetail(order.quoteID, order.ecastatusint)">
                        <a><span class="cursor demibold green">ID {{order.quoteID}}</span></a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="origin">
                    <th mat-header-cell *matHeaderCellDef>Origin</th>
                    <td mat-cell *matCellDef="let quote">
                        <span class="origin-pill" [class.origin-pill-online]="quote.origin === 'Online'"
                            [class.origin-pill-unknown]="quote.origin === 'Unknown'"
                            [matTooltip]="quote.origin === 'Online' ? 'Created by customer'
                                : quote.origin === 'Sales' ? 'Created by Quickparts'
                                : 'Origin could not be determined'">
                            {{quote.origin}}
                        </span>
                    </td>
                </ng-container>

                <!-- Date Created Column -->
                <ng-container matColumnDef="datecreated">
                    <th mat-header-cell *matHeaderCellDef>Date Created</th>
                    <td mat-cell *matCellDef="let order">
                        <span>{{order.datecreated}}</span>
                    </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let order">
                        <span class="demibold green">{{order.status}}</span>
                    </td>
                </ng-container>

                <!-- Amount Column — 3621. Unsymbolled for the same reason as on quotes. -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let order">
                        <span>{{ order.amount != null ? (order.amount | number:'1.2-2') : '—' }}</span>
                    </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let order">
                        <span id="out{{order.quoteID}}" class="small grey demibold ms-3">ECA Status Set</span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="activityColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: activityColumns;"></tr>
            </table>
            <mat-paginator #orderPaginator
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 50]"
                showFirstLastButtons>
            </mat-paginator>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
